export const sortByRecentDate = (postDates=[])=>{
    return postDates?.sort((a,b)=> Date.parse(b?.updatedAt) - Date.parse(a?.updatedAt))

}
export const sortByRecentYear = (teams = [])=>{
    return teams?.sort((a,b)=> a.year - b.year)

}

export const sortPlayerByVote = (players = [])=>{
    return players?.sort((a,b)=> b.votos - a.votos )

}